<template>
  <div id="app">
    <!-- <h3 class="title">{{ msg }}</h3> -->
    <div class="amap-wrapper">
      <!-- <el-amap class="amap-box" :vid="'amap-vue'">
          <el-amap-marker v-for="marker in markers" :lebel="marker.lebel" :position="marker.position"></el-amap-marker>
      </el-amap> -->
      <div id="amapContainer" style="width:100vw;height:100vh;"></div>
    </div>
  </div>
</template>

<script>
import {lazyAMapApiLoaderInstance} from "vue-amap";
export default {
  data () {
    return {
      msg: 'vue-amap向你问好！',
      markers: []
    }
  },
  mounted() {
        // this.$nextTick(() => {
    this.$api.activity.hpaddress().then((res)=>{
        let points = res.data
        // points.forEach((item, index) => {
        //     let position = [item.lon,item.lat]
        //     let lebel = {
        //         content:`<div class='info'>${item.name}</div>`,
        //         offset: new AMap.Pixel(20, 20),
        //         direction: 'center'
        //     }
        //     this.markers.push({
        //         position,lebel
        //     })

        // });
        lazyAMapApiLoaderInstance.load().then(() => {
            this.map = new AMap.Map("amapContainer", {
                resizeEnable: true,
                // center: [121.491708,31.196219],
                // zooms: [12,16],
                zoom: 13,
                mapStyle: "amap://styles/whitesmoke",
            });
            points.forEach((item, index) => {
                let position = [item.lon,item.lat]
                var markerContent = '' +
                '<div class="custom-content-marker">' +
                '   <img src="https://oss.mcloud.moveclub.cn/mpmsalpha/20210323/1616505311-6059e9df2399d.png">' +
                '</div>';
                var content = '<div class="first-point">' + item.name + "</div>";
                var marker = new AMap.Marker({
                    position,
                    // animation:"AMAP_ANIMATION_DROP",
                    // title: item.name,
                    content: markerContent,
                    offset: new AMap.Pixel(-12.5,-12.5), //设置偏移量
                    anchor: 'bottom-left', // 设置锚点方位
                })
                marker.setMap(this.map);
                marker.setLabel({
                    offset: new AMap.Pixel(20, 20),  //设置文本标注偏移量
                    content, //设置文本标注内容
                    direction: 'center' //设置文本标注方位
                });
            });
        });
    })
        

        // })

    }
}
</script>
<style>
 .custom-content-marker {
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
  }

  .custom-content-marker img {
      width: .3rem;
      height: .3rem;
  }

  .custom-content-marker .close-btn {
      width:100%;
      background: #ffffff;

      font-weight: bold;
      height:.18rem;
      font-size:.12rem;
      text-align: center;
      line-height: .18rem;
      /* border-radius: 50%; */
      color: #FC5C4C;
      border:.02rem solid #FC5C4C;

  }
  .first-point{
    color: #FC5C4C;
    border:.04rem solid #FC5C4C;
  }
</style>
<style lang="less" scoped>
.amap-wrapper {
  width:100vw;
  height:100vh;
}

</style>